import type { ExtractPropTypes } from 'vue'

export const floatProps = {
	slide: { type: Boolean, default: false },
	show: { type: Boolean, default: false },
	lazy: { type: Boolean, default: true },
	position: { type: String, default: '' },
	width: { type: [Number, String], default: '' },
	height: { type: [Number, String], default: '' },
	left: { type: [Number, String], default: '' },
	top: { type: [Number, String], default: '' },
	align: { type: String, default: 'auto' },
	mask: { type: Boolean, default: true },
	zIndex: { type: Number, default: 0 },
	closeOnBlur: { type: Boolean, default: true },
	beforeClose: { type: Function, default: null },
	beforeOpen: { type: Function, default: null },
	afterClose: { type: Function, default: null },
	afterOpen: { type: Function, default: null },
	dx: { type: [Number, String], default: 0 },
	dy: { type: [Number, String], default: 0 },
	mode: { type: String, default: '' },
	global: { type: Boolean, default: true },
	speed: { type: [Number, String], default: 100 }
}

export type FloatProps = ExtractPropTypes<typeof floatProps>

export const floatEmits = ['click', 'mouseenter', 'mouseleave', 'beforeOpen', 'opened', 'beforeClose', 'closed']

export type FloatEmits = typeof floatEmits
